import React from 'react';

type State = {
    hasError: boolean;
};
export class ErrorBoundary extends React.Component {
    state: State  = {
        hasError: false
    };

    // Use this to test with...
    // constructor(props) {
    //   super(props);
    //   setTimeout(()=>{
    //     this.setState({
    //       hasError: true
    //     });
    //   }, 3000);
    // }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      console.error(error);
      console.error(errorInfo);
    }

    reset() {
      this.setState({
        hasError: false
      });
    }
  
    render() {
      if (this.state.hasError) {
        return (
          <div className="error-boundary">
            <p>
              Oops, something went wrong. Please try again. If the problem persists, <a href="mailto:support@labsmarts.com" target="_top">send us an email</a> with a description of what you were doing when this error occurred.
            </p>
            <p>  
              Thank you for your patience and your help in making our software the best it can be for you and your fellow practitioners!
            </p>
            
            Click <a href="/" onClick={this.reset}>here</a> to return to the app.
          </div>
        );
      }
  
      return this.props.children; 
    }
  }